// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AssessmentCard_wrapper__p3kUT","small":"AssessmentCard_small___6Eei","content":"AssessmentCard_content__yxDUx","passed":"AssessmentCard_passed__tPl_2"};